import React from 'react';
import { PatternFormat } from 'react-number-format';

const PhoneNumberFormatCustom = React.forwardRef(function PhoneNumberFormatCustom(props, ref) {
    const { onChange, name, ...other } = props;
    return (
        <PatternFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name,
                        // Pass the unformatted (digits only) value or use values.formattedValue if you prefer
                        value: values.value,
                    },
                });
            }}
            // This will format the input as (123) 456-7890
            format="(###) ###-####"
            mask="_"
        />
    );
});

export default PhoneNumberFormatCustom;
